module.exports = __webpack_public_path__ + "img/file-document.1d6b9c28.svg";